import { render, staticRenderFns } from "./Authorization.vue?vue&type=template&id=322a9e58&"
import script from "./Authorization.vue?vue&type=script&lang=js&"
export * from "./Authorization.vue?vue&type=script&lang=js&"
import style0 from "./Authorization.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VTextField})
